import styled from 'styled-components';

export const Container = styled.div`
  .modal-content {
    border-radius: 12px !important;
    padding: 0 !important;
  }

  .modal-backdrop.show {
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px); /* Safari */
    background-color: rgba(0, 0, 0, 0.25) !important; /* precisa ser transparente */
  }

  .modal-dialog {
    opacity: 0.3 !important;
  }

  a {
    color: #1e6dd8;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
`;
